// Imports
// ------
import React from 'react';
import styled from 'styled-components';
import { ExtButtonLink, sharedButtonStyles } from '@reuse';
import { breakup } from '@break';
import AniLink from "gatsby-plugin-transition-link/AniLink";
import { themeStyles } from '@theme/theme';


// Styles
// ------
const LegalList = styled.ul`
    text-align: right;
    list-style: none;
    position: relative;
    padding-left: ${props => props.theme.mpad};

    ${breakup.large`
        padding-left: 0;
    `}
`;

const StyledButton = styled(AniLink)`
    ${sharedButtonStyles}
`;

const LegalLink = styled.li`
    display: block;
    margin: 2.4rem 0;

    ${breakup.large` margin: 0 0 6rem 0; `}

    a {
        transition: all .25s ease-in-out;
        color: white;

        &:hover {
            color: white;
            opacity: 0.5;
        }
    }
`;

// Components
// ------
export default class Legal extends React.PureComponent {
    render() {
        return (
            <LegalList>
                <LegalLink>
                    <StyledButton cover direction="right" bg={themeStyles.bc1} to="/terms-and-conditions/">Terms</StyledButton>
                </LegalLink>

                <LegalLink>
                    <ExtButtonLink target="_blank" href={this.props.privacyPolicy} download>Privacy</ExtButtonLink>
                </LegalLink>

                <LegalLink>
                    <ExtButtonLink target="_blank" href={this.props.reviewsLink}>Reviews</ExtButtonLink>
                </LegalLink>
            </LegalList>
        );
    }
}